import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PmorderFilterCriteria from './PmorderFilterCriteria'
import PmorderListImpl from './PmorderListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PmorderAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPmorderDashboardPmorderList } from '../../store/slice/PharmaSlice';

export default function PmorderListView({setShowEdit,setPmorderId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.pmorderDashboard);   

    const [filteredPmorderList, setFilteredPmorderList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { pmorderDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (pmorderDashboard.pmorderList.length>-1){
        setFilteredPmorderList(pmorderDashboard.pmorderList);
        transformToCardFormat(pmorderDashboard.pmorderList, setCardList);
      }
    },[pmorderDashboard.pmorderList])

    useEffect(()=>{
          transformToCardFormat(filteredPmorderList, setCardList);
      },[filteredPmorderList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.productid==='' && filterCriteria.orderid==='' && filterCriteria.pmstatus==='' && filterCriteria.orderdate==='' && filterCriteria.unitid==='' && filterCriteria.unitname==='' && filterCriteria.qty==='' && filterCriteria.receivedon==='' && filterCriteria.receivedqty==='' && filterCriteria.availableqty==='' && filterCriteria.vendorid==='' && filterCriteria.vendorname==='' && filterCriteria.requiredqty==='' && filterCriteria.orderedqty==='' ){
            setFilteredPmorderList(pmorderDashboard.pmorderList);
            transformToCardFormat(pmorderDashboard.pmorderList, setCardList);

        } else {
            setFilteredPmorderList(
                pmorderDashboard.pmorderList
                    .filter(pmorder=> pmorder.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(pmorderDashboard.filteredPmorderList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PmorderListImpl
                    setShowEdit={setShowEdit}
                    setPmorderId = {setPmorderId}
                    tableList={filteredPmorderList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}